import React from "react";

export default function BackupImageSettingsTabs({
  sizeOptions,
  selectedBannerId,
  onTabClick,
}) {
  return (
    <div className="backup-image-settings-tabs">
      {sizeOptions.map((option) => (
        <button
          type="button"
          key={option.value}
          className={`backup-image-settings-tab ${option.value === selectedBannerId ? "active" : ""}`}
          onClick={() => onTabClick(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
